import { useEffect, useRef, useState } from 'react'

import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers'

const useLanguageTextInput = ({
  languages,
  value,
  onChange,
  validateEmptyOnBlur,
  externalErrorLanguages,
  defaultLanguage,
}) => {
  const currentLanguage = getCurrentAvailableLanguage(languages, defaultLanguage)
  const [textLanguage, setTextLanguage] = useState(currentLanguage)
  const [emptyErrors, setEmptyErrors] = useState({})
  const previousErrorLanguages = useRef(externalErrorLanguages)

  useEffect(() => {
    const newErrorLanguages = externalErrorLanguages.filter(
      language => !previousErrorLanguages.current.includes(language)
    )

    previousErrorLanguages.current = externalErrorLanguages

    if (newErrorLanguages.length === 0 || externalErrorLanguages.includes(textLanguage)) return

    setTextLanguage(newErrorLanguages[0])
  }, [externalErrorLanguages, textLanguage])

  const hasError = language => {
    return Boolean(emptyErrors?.[language]) || externalErrorLanguages.includes(language)
  }

  const handleChange = e => {
    onChange(e.target.value, textLanguage)
  }

  const handleBlur = () => {
    if (!validateEmptyOnBlur) {
      return
    }

    languages.forEach(lang => {
      setEmptyErrors(prev => ({ ...prev, [lang]: !value?.[lang] }))
    })
  }

  return { textLanguage, setTextLanguage, hasError, handleChange, handleBlur }
}

export default useLanguageTextInput
